import { setLoading, setMessage, setSystemSettings } from 'state/reducers/system_settings.reducers';
import { setErrorMessage } from 'utils';
import API from 'services/api.services';
import { API_GET_ALL_SYSTEM_SETTINGS } from 'constants/db.constants';

export function getAllSystemSettings() {
	return async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const response = await API.getInstance().get(API_GET_ALL_SYSTEM_SETTINGS, {}, {}, {}, true);

			if (response?.data?.systemSettings) {
				// The API returns all settings grouped by domain
				dispatch(setSystemSettings(response.data.systemSettings));
			} else {
				dispatch(setSystemSettings({}));
			}
		} catch (error) {
			setErrorMessage(setMessage, error);
		} finally {
			dispatch(setLoading(false));
		}
	};
}
